function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M256 32C114.6 32 .0272 125.1 .0272 240c0 49.59 21.38 95.03 56.97 130.7c-12.5 50.39-54.27 95.27-54.77 95.77c-2.188 2.297-2.781 5.734-1.5 8.734C2.042 478.2 4.813 480 8 480c66.31 0 116-31.78 140.6-51.39C181.3 440.9 217.6 448 256 448c141.4 0 255.1-93.09 255.1-208S397.4 32 256 32zM256 432c-35.12 0-69.36-6.184-101.8-18.38L145.7 410.4l-7.105 5.666c-20.2 16.11-60.14 42.04-112.7 47.06c14.44-18.29 37.42-51.68 46.57-88.59l2.172-8.758l-6.371-6.391C34.1 325.1 16 283.8 16 240c0-105.9 107.7-192 240-192s240 86.13 240 192S388.3 432 256 432z"
});

function SvgCommentThin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentThin);
export default __webpack_public_path__ + "static/media/comment-thin.65852924.svg";
export { ForwardRef as ReactComponent };